import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';

import messages from './messages';

interface DiscardChangesModalProps {
	isOpen: boolean;
	onKeepEditing: () => void;
	onLeaveWithoutSaving: () => void;
}

export const DiscardChangesModal = ({
	isOpen,
	onKeepEditing,
	onLeaveWithoutSaving,
}: DiscardChangesModalProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	if (!isOpen) {
		return null;
	}

	return (
		<Modal onClose={onKeepEditing}>
			<ModalHeader>
				<ModalTitle>{formatMessage(messages.modalTitle)}</ModalTitle>
			</ModalHeader>
			<ModalBody>{formatMessage(messages.modalDescription)}</ModalBody>
			<ModalFooter>
				<Button appearance="subtle" onClick={onKeepEditing}>
					{formatMessage(messages.keepEditingButton)}
				</Button>
				<Button appearance="warning" onClick={onLeaveWithoutSaving}>
					{formatMessage(messages.leaveWithoutSavingButton)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
